import { POST_TEXT_COLOR_PATH } from '@wix/communities-blog-client-common';
import withSettingsColor from './with-settings-color';

export default withSettingsColor(POST_TEXT_COLOR_PATH, 'separatorColor', undefined, 0.2);
